import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'antd';
import { Field } from 'redux-form';
import { SelectField, TextField } from 'redux-form-antd';

import './CampaignsAdd.css';
import RangePicker from '../RangePicker';
import FormValueSelector from '../../../containers/FormValueSelector';

const formItemLayout = {
  colon: false,
  labelCol: {
    xs: { span: 26 },
    sm: { span: 6 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
  },
};

const CampaignsAdd = ({
  onCancel,
  visible,
  handleSubmit,
  submitting,
  adminOptions,
  advertiserOptions,
  publisherOptions,
  isEdit,
}) => (
  <Modal
    width={600}
    confirmLoading={submitting}
    onCancel={onCancel}
    onOk={handleSubmit}
    okText={isEdit ? 'Update' : 'Create'}
    title={isEdit ? 'Update Campaign' : 'New Campaign'}
    visible={visible}
  >
    <form onSubmit={handleSubmit} className="campaignForm">
      <Field {...formItemLayout} label="Name" name="name" component={TextField} />
      <RangePicker
        formItemLayout={formItemLayout}
        showTime={false}
        displayFormat="YYYY-MM-DD"
        apiFormat="YYYY-MM-DD"
      />
      <Field
        {...formItemLayout}
        label="Campaign Lead"
        optionFilterProp="title"
        optionLabelProp="title"
        mode="combobox"
        format={a => a && `${a}`}
        name="actor_id"
        component={SelectField}
        options={adminOptions}
        placeholder="Select or type a campaign lead"
      />
      <Field
        {...formItemLayout}
        showSearch
        mode="combobox"
        optionFilterProp="title"
        optionLabelProp="title"
        label={
          <FormValueSelector fieldName="advertiser_uuid">
            {uuid =>
              !advertiserOptions.find(a => a.value === uuid) ? 'New Advertiser' : 'Advertiser'
            }
          </FormValueSelector>
        }
        name="advertiser_uuid"
        component={SelectField}
        options={advertiserOptions}
        placeholder="Select or type an advertiser"
      />

      <Field
        {...formItemLayout}
        showSearch
        optionFilterProp="title"
        optionLabelProp="title"
        label="Seller (Publisher)"
        name="seller_pub_uuid"
        component={SelectField}
        options={publisherOptions}
        disabled={isEdit}
        placeholder="Select a seller"
      />
    </form>
  </Modal>
);

const optionShape = PropTypes.arrayOf(
  PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  })
);

CampaignsAdd.defaultProps = {
  submitting: false,
  isEdit: false,
};

CampaignsAdd.propTypes = {
  isEdit: PropTypes.bool,
  submitting: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  visible: PropTypes.bool.isRequired,
  adminOptions: optionShape.isRequired,
  advertiserOptions: optionShape.isRequired,
  publisherOptions: optionShape.isRequired,
};

export default CampaignsAdd;
